import { useFormikContext } from "formik";
import React, { FC, useMemo } from "react";

import closeIcon from "../../../../assets/closeCircle.svg";
import { GovernanceConfigurationType } from "../../../../common/enums/clubs-wizard.enum";
import { UserRole } from "../../../../common/enums/common.enums";
import { ICreateClubWizardForm } from "../../../../common/interfaces/clubs-wizard.interface";
import {
  IFormField,
  IOption,
} from "../../../../common/interfaces/common.interface";
import WizardField from "../../../WizardField/WizardField";
import "./MemberItem.scss";

interface IMemberItem {
  index: number;
  isOwner: boolean;
  field: IFormField;
  removeItem: () => void;
}

const MemberItem: FC<IMemberItem> = ({ index, isOwner, removeItem }) => {
  const { values } = useFormikContext<ICreateClubWizardForm>();

  const roleOptions = useMemo(() => {
    const options: IOption[] = [];
    values.member &&
      options.push({ label: UserRole.member, value: UserRole.member });

    values.curator &&
      options.push({ label: UserRole.curator, value: UserRole.curator });

    values.investor &&
      options.push({ label: UserRole.investor, value: UserRole.investor });

    return options;
  }, [values]);

  return (
    <div className="member-item">
      <div className="member-item__header">
        <p className="member-item__title">
          {values.governance === GovernanceConfigurationType.ProjectFundraise
            ? "Participant"
            : "Member"}{" "}
          #{index + 1} {isOwner && "(You)"}
        </p>
        {!isOwner && (
          <img src={closeIcon} alt="Remove item" onClick={removeItem} />
        )}
      </div>
      <div className="member-item__input-row">
        <div className="member-item__pubkey">
          <WizardField
            type="text"
            name={`initialMembers.${index}.pubKey`}
            placeholder="Paste wallet address here"
            label="Public key"
            disabled={isOwner}
          />
        </div>
        <div className="member-item__role">
          <WizardField
            type={isOwner ? "text" : "select"}
            name={`initialMembers.${index}.role`}
            placeholder=""
            label="Role"
            selectOptions={roleOptions}
            disabled={isOwner}
          />
        </div>
      </div>
    </div>
  );
};

export default MemberItem;
